import axios from 'axios';
// eslint-disable-next-line
export const getGeoData = async () => {
  try {
    const geoData = await axios.get(
      'https://geolocation-db.com/json/85249190-4601-11eb-9067-21b51bc8dee3'
    );
    return geoData.data;
  } catch (err) {
    console.error(err.message);
  }
};
